module.exports = __webpack_public_path__ + "static/a3-4d1aeaab24a66f50db47afdc88812da8.png";